
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible'
import http from './api/ajax.js' //ajax请求
import tools from './api/tools.js' //工具
import regulars from './api/regulars.js' //工具
import notice from './api/notice.js' //弹窗
import config from './api/common.js' //公共变量
import title from 'vue-wechat-title' //标题更新
import filter from './api/filter.js' //公共过滤器
import VueLazyload from 'vue-lazyload' //图片懒加载
import weixin from './api/weixin' //微信方法
import app from './api/app' //原生方法
import Vant from 'vant' // vant-ui
import 'vant/lib/index.css'
import './sass/common.scss'

weixin.wxmplogin({}, function () {
  initVue();
})
async function initVue() {
  await tools.getDeviceKey();
  Vue.use(http)
  Vue.use(tools)
  Vue.use(regulars)
  Vue.use(notice)
  Vue.use(filter)
  Vue.use(title)
  Vue.use(config)
  Vue.use(weixin)
  Vue.use(app)
  Vue.use(Vant)


  Object.keys(filter).forEach(key => {
    Vue.filter(key, filter[key])
  })

  Vue.directive('title', {
    inserted: function (el, binding) {
      tools.setWebTitle(binding.value);
    },
    update: function (el, binding) {
      tools.setWebTitle(binding.value);
    }
  });
  // 将API方法绑定到全局
  Vue.prototype.$http = http;
  Vue.prototype.$tools = tools;
  Vue.prototype.$regulars = regulars;
  Vue.prototype.$notice = notice;
  Vue.prototype.$config = config;
  Vue.prototype.$weixin = weixin;
  Vue.prototype.$app = app;

  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}